import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

import { useSelectedView } from '../useSelectedView.ts';

export const useHomeNavigationAnalytics = () => {
	const selectedView = useSelectedView();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(id: string) => {
			createAnalyticsEvent({
				type: 'sendUIEvent',
				data: {
					source: `${selectedView}Screen`,
					action: 'clicked',
					actionSubject: 'homeNavigationItem',
					actionSubjectId: id,
					attributes: {
						navigationLayer: 'global',
						navigationContainer: 'sidebar',
						navdexPointType: START_TOUCH,
						navVersion: '3',
					},
				},
			}).fire();
		},
		[createAnalyticsEvent, selectedView],
	);
};
